import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import SkeletonType1 from "@/app/components/ui/Skeletons/Type1";
import { useOverBookingsListAPI } from "@/app/hooks/api_hooks/bookings/useOverBookingsListAPI";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { ISlotsState, setOverBookingList } from "@/app_redux/reducers/slices/auth/slots_slice";
import { FC, useEffect } from "react";
import { IBookingOverbookingProps } from "../interface";
import OverBookingTableForm from "./OverBookingTableForm";

const OverBookingSlotsComponent: FC<IBookingOverbookingProps> = () => {
  /* Instantiations Starts */

  const { NO_PWL_RESULTS } = useImageConstants();
  const isOverBookingListInProgress = useLoader("isOverbookingSlotsInProgress");
  const { getRouteKey } = useRouter();
  const { routeState: slotsRouteState } = useRouteInfo(getRouteKey("SLOTS", "id"));

  const dispatch = useAppDispatch();

  /* Instantiations Ends */

  /* API Starts */

  const fetchOverbookingList = useOverBookingsListAPI();

  /* API Ends */

  /* Redux States Starts */
  const { overBooking: overbookingList } = slotsRouteState?.state as ISlotsState;

  /* Redux States Ends */
  /* Actions / Handlers */

  useEffect(() => {
    fetchOverbookingList();
    return () => {
      dispatch(
        setOverBookingList({
          data: [],
        }),
      );
    };
  }, []);

  /* Use Effect Ends */

  return (
    <div className="p-4 mt-4">
      <div className="">
        <p className="text-gray-700 font-semibold pl-2 text-lg">Allowed Overbookings</p>
      </div>
      <div className="mt-2">
        {!isOverBookingListInProgress ? (
          overbookingList?.length > 0 ? (
            overbookingList?.map((overBooking, idx: number) => {
              return (
                <OverBookingTableForm
                  services={overBooking.services}
                  hideHeader={idx > 0}
                  key={overBooking?.id}
                  overBookingDetails={overBooking}
                />
              );
            })
          ) : (
            <NoDataFoundComponent
              imageURL={NO_PWL_RESULTS}
              message="No Allowed Overbookings"
              description="No allowed overbookings are found, please either allow it or contact team."
            />
          )
        ) : (
          <>
            <SkeletonType1 className="mt-2" />
            <SkeletonType1 className="mt-2" />
          </>
        )}
      </div>
    </div>
  );
};
export default OverBookingSlotsComponent;
